module.exports = __webpack_public_path__ + "img/RoamingDocuments.3e6f34d6.svg";